import MuiDialogTitle, { DialogTitleProps } from "@mui/material/DialogTitle";
import { IconButton } from "@/components/Button";
import { CloseIcon } from "@/components/Icon";
import styles from "./Dialog.module.scss";
import cx from "classnames";

const DialogTitle: React.FC<
  DialogTitleProps & {
    hasCloseButton?: boolean;
    onClose?: () => void;
    disableClose?: boolean;
    mobileMode?: boolean;
  }
> = ({
  children,
  hasCloseButton = true,
  onClose,
  disableClose = false,
  className,
  mobileMode,
  ...props
}) => {
  return (
    <MuiDialogTitle
      {...props}
      className={cx(className, {
        [styles.titleWithClose]: hasCloseButton,
        [styles.mobileContainer]: mobileMode,
      })}
    >
      {children}
      {hasCloseButton && (
        <IconButton
          className={cx(styles.closeButton, {
            [styles.mobileCloseButton]: mobileMode,
          })}
          onClick={onClose}
          disabled={disableClose}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    </MuiDialogTitle>
  );
};

export default DialogTitle;
